import { render, staticRenderFns } from "./NotificationBrandingTemplateSetup.vue?vue&type=template&id=b31122f0&scoped=true"
import script from "./NotificationBrandingTemplateSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationBrandingTemplateSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationBrandingTemplateSetup.vue?vue&type=style&index=0&id=b31122f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31122f0",
  null
  
)

export default component.exports